import makeStyles from '@mui/styles/makeStyles'

import Paper from '@mui/material/Paper'

import { userDialogStyles } from '../../commonStyles'

import { useReloadFeatures } from '../hooks'

import logo from '../../assets/logo-full.svg'

import BrandButton from '../../subcomponents/brand/BrandButton'

const MESSAGE = 'We couldn’t load this page. Check your connection and try again.'

const useStyles = makeStyles(
  theme => ({
    ...userDialogStyles(theme),

    actions: {
      display: 'flex',
      justifyContent: 'center',
      padding: theme.spacing(2, 0, 0)
    }
  }),
  {
    name: 'FeatureUnavailable'
  }
)

/**
 * FeatureUnavailable stands in for a flagged page while the feature flags could not be fetched: unlike a flag
 * that is off, that is not a page that doesn’t exist, so the visitor gets another try rather than a 404.
 */
const FeatureUnavailable = props => {
  const reloadFeatures = useReloadFeatures()

  const handleRetry = event => reloadFeatures()

  const classes = useStyles(props)
  return (
    <div className={classes.root}>
      <div className={classes.dialogContainer}>
        <Paper className={classes.dialog}>
          <section className={classes.logo}>
            <img src={logo} alt="Undivided Logo" />
          </section>

          <h2 className={classes.prompt} role="alert">
            {MESSAGE}
          </h2>

          <section className={classes.actions}>
            <BrandButton variant="contained" onClick={handleRetry}>
              Try again
            </BrandButton>
          </section>
        </Paper>
      </div>
    </div>
  )
}

export default FeatureUnavailable
